import React from 'react'

import { Button, Card, Col, Drawer, Form, Icon, notification, Row, Select } from 'antd'
import _ from 'lodash'
import styles from './styles.less'
import { FormUtils as GetAllFormFields } from 'sz-react-utils'
import { hideLoader, showLoader } from '../../modules/actions'
import Request from '../../request'
import { connect } from 'react-redux'

@Form.create()

class BranchInboxEmailView extends React.Component {
    state = {
        visible: true,
        templateArr: [],
        generatedInvoice: {}
    }

    componentWillMount() {

    }

    loadSmsTemplate = async () => {
        let templateArr = await Request.getTemplatesForCommunication('BranchInvoiceEmail')
        this.setState({ templateArr })
    }

    handleSubmit = e => {
        const { dispatch, form } = this.props
        const { invoiceId } = this.props;
        e.preventDefault()
        dispatch(showLoader())
        form.validateFieldsAndScroll(async (err, valData) => {
            if (!err) {
                let values = _.clone(valData);
                values.invoiceId = invoiceId;
                let x = await Request.sendBranchInvoice(values)
                dispatch(hideLoader())
                if (!x.error) {
                    notification.success({
                        message: 'Invoice sent successfully'
                    });
                    this.onClose();
                } else {
                    notification.error({
                        message: 'Error Saving',
                        description: x.msg
                    })
                }
            }
        })
    }

    onClose = () => {
        this.setState({
            visible: false
        })

        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }

    constructor(props) {
        super(props)
        this.table = React.createRef();
        this.loadSmsTemplate();
    }

    render() {
        const { dispatch, form } = this.props
        const {
            form: { getFieldDecorator, setFieldsValue }
        } = this.props
        const { invoiceId } = this.props;
        const { templateArr, generatedInvoice } = this.state

        const inputTypes = {
            fields: [
                {
                    label: '',
                    key: 'invoiceId',
                    type: 'hidden',
                },
                {
                    label: 'To',
                    key: 'emailTo',
                    required: true
                },
                {
                    label: 'Subject',
                    key: 'subject',
                    required: true
                },
                {
                    label: 'Choose Template',
                    key: 'templateId',
                    type: 'select',
                    showSearch: true,
                    required: true,
                    allowClear: true,
                    width: 500,
                    keyAccessor: x => x.templateData,
                    valueAccessor: x => x.templateName,
                    disabled: false,
                    options: templateArr ? templateArr : {},
                    onChange: v => {
                        this.props.form.setFieldsValue({ templateId: v })
                        this.props.form.setFieldsValue({ template: v })
                    }
                },
                {
                    label: 'Template',
                    key: 'template',
                    required: true,
                    type: 'editor',
                    rows: 15
                }
            ]
        };


        return (
            <Drawer
                title={
                    <div>
                        {'Invoice Email Inbox'} {' '}
                        <a onClick={this.onClose} style={{ float: 'right', color: 'black' }}>
                            <Icon type={'close'} />
                        </a>
                    </div>
                }
                placement="right"
                closable={false}
                onClose={this.onClose}
                width={1000}
                visible={this.state.visible}>
                <Card>
                    <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                        <div className={styles.formDiv}>
                            <GetAllFormFields
                                inputSchema={inputTypes}
                                getFieldDecorator={getFieldDecorator}
                            />
                        </div>
                        <Row>
                            <Col span={8} />
                            <Col span={8}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    style={{ marginBottom: 10 }}
                                    loading={this.props.loading}>
                                    submit
                                </Button>
                            </Col>
                            <Col span={8} />
                        </Row>
                    </Form>
                </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({ global, router }) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BranchInboxEmailView)